import React, {useContext} from 'react';
import './cart.css';
import { ShopContext } from '../../componets/context/shopContext';

export const CartItem = (props) => {
    const { id, productName, price, productImage } = props.data;
    const { cartItems , setCartItems,addToCart, removeFromCart} = useContext(ShopContext);

    const handleChange = (e) => {
        const newQuantity = parseInt(e.target.value, 10) || 0;
        setCartItems(prev => ({...prev, [id]: newQuantity}));
    };
    return(
        <div className='cart'>
            <div className='cartItem'>
                <img src={productImage} alt='productImage' />
                <div className='description'>
                    <p>
                        {" "}
                    <b>{productName}</b>
                    </p>
                    <p>
                        ₹ {price}
                    </p>
                        <div className='counter'>
                            <button onClick={() => removeFromCart(id)}> - </button>
                            <input 
                            type="number" 
                            value={cartItems[id] || 0} 
                            onChange={handleChange} 
                            ></input>
                            <button onClick={() => addToCart(id)}> + </button>
                        </div>
                </div>
            </div>
        </div>
    );
};